module.exports = __webpack_public_path__ + "static/img/bg-yundongyuan.564062c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cha/bg-yundongyuan.png
// module id = 959
// module chunks = 0